import { Outlet, createFileRoute } from '@tanstack/react-router'

import LanguageSwitcher from '@/components/LanguageSwitcher.tsx'
import ThemeSwitcher from '@/components/ThemeSwitcher.tsx'

export const Route = createFileRoute('/auth')({
  component: AuthLayout,
})

function AuthLayout() {
  return (
    <div className="relative flex min-h-screen w-full items-center justify-center overflow-hidden">
      {/* Language and Theme Switchers */}
      <div className="absolute top-4 right-4 z-10 flex items-center gap-2">
        <ThemeSwitcher />
        <LanguageSwitcher />
      </div>

      <div className="relative h-screen w-full sm:mx-auto sm:h-full sm:max-w-120">
        <div className="flex h-full w-full items-center justify-center bg-white py-8 sm:items-start sm:rounded-xl sm:bg-white/80 sm:py-12 sm:shadow-xl sm:backdrop-blur-lg dark:bg-neutral-800 sm:dark:bg-neutral-800/80">
          <div className="w-full max-w-md">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  )
}
